module.exports = __webpack_public_path__ + "img/_latvia.1879756c.png";